export default {
    day: '2025-11-10',
    content: {
        school: [
            {
                unlock: 'schoolChemistrySubfeature',
                type: 'bugfix',
                text: '650'
            },
        ],
        treasure: [
            {
                type: 'change',
                text: '648'
            },
            {
                type: 'bugfix',
                text: '649'
            },
        ],
    }
}
